export default __webpack_public_path__ + "static/media/fontsWaterMarks.2428088d.svg";